import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { immediateToast } from "izitoast-react";
import Select from "react-select";

import { Spinner } from "../../Components/Spinner/Spinner";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import workoutApiCalled from "../../redux/actionCreators/workoutApiCalled";

import projectSettings from "../../assets/Js/projectSettings";

import { closeModel } from "../../assets/Js/closeModel";

import { Date_Error } from "../../assets/Js/errorMessage";

import shouldDuplicate from "../../redux/actionCreators/shouldDuplicate";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

const mapDispatchToProps = (dispatch) => {
  return {
    workoutApiCalled: () => dispatch(workoutApiCalled()),
    shouldDuplicate: () => dispatch(shouldDuplicate(false)),
  };
};

const mapStateToProps = (state) => {
  return {
    trackInfo: state.trackInfo,
    isDupilicate: state.isDupilicate,
  };
};

const setsOption = [...Array(25)].map((currVal, index) => ({
  label: index + 1,
  value: index + 1,
}));

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class Lift extends Component {
    constructor(props) {
      super(props);

      this.nameRef = createRef();
      this.linkRef = createRef();
      this.notesRef = createRef();

      this.state = {
        duplicateTrackId: null,
        id:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Id
            : null,
        totalSets: 10,
        selectedSets: 0,
        isLoading: false,
        date:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Schedule
            : this.props.workoutDate
            ? this.props.workoutDate
            : "mm/dd/yyyy",
        name:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Name
            : "",
        link:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.videoUrl
            : "",
        notes:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Notes
            : "",
        descriptionArray: [{ reps: "", percentage: "" }],
        selectedSetOption: { label: 1, value: 1 },
        liftOptions: [],
      };
    }

    componentDidMount() {
      this.descriptionSeperate();
      this.getLiftMovements();
      this.setState({
        duplicateTrackId: this.props.duplicateTrackId,
      });
    }
    componentDidUpdate = (prevProps) => {
      if (prevProps.duplicateTrackId !== this.props.duplicateTrackId) {
        this.setState({ duplicateTrackId: this.props.duplicateTrackId });
      }
    };
    getLiftMovements = async () => {
      let url = `${projectSettings.baseUrl}/workouts/getliftmovements`;
      let header = true;
      let data = null;
      let type = "GET";
      let token = getPlainToken();

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        this.setState({ isLoading: false });
        if (response.type === "error") {
          this.setState({ showError: true });
        } else if (response.type === "success") {
          let tempLiftOptions = [];

          response.data.map((currVal, index) => {
            tempLiftOptions.push({ label: currVal.Name, value: currVal.Id });
          });
          this.setState({ liftOptions: tempLiftOptions });
          this.setState({ selectedLiftOption: tempLiftOptions[0] });
        }
      }
    };

    descriptionSeperate = () => {
      var newArray = [];
      var repsPercentage = {
        percentageValue: "",
        reps: "",
      };

      if (
        this.props &&
        this.props.editableWorkout &&
        this.props.editableWorkout.Description
      ) {
        var str = this.props.editableWorkout.Description;
        do {
          repsPercentage = {
            percentage: "",
            resp: "",
          };
          if (str.indexOf("#") === -1 || str.indexOf("\n") === -1) break;
          let index1 = str.indexOf("#"),
            index2 = str.indexOf("\n");
          var subStr = str.slice(index1, ++index2);
          var repsIndex = subStr.indexOf("Reps");
          var startReps = "#" + (newArray.length + 1) + ": ";
          let newPercentage = subStr.slice(repsIndex + 5, subStr.indexOf("%"));
          if (newPercentage === "0" || newPercentage === "100") {
            newPercentage = "";
          }
          repsPercentage = {
            percentage: newPercentage,
            reps: subStr.slice(startReps.length, repsIndex),
          };

          newArray.push(repsPercentage);
          str = str.replace(subStr, "");
        } while (true);

        this.setState({
          selectedSetOption: { label: newArray.length, value: newArray.length },
        });

        this.setState({
          descriptionArray: newArray,
        });
      }
    };

    requiredDate = (inputDate) => {
      if (inputDate !== "yyyy/mm/dd") {
        let date = new Date(inputDate);
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      } else {
        return "yyyy/mm/dd";
      }
    };

    submitHandler = (e) => {
      e.preventDefault();

      if (this.props.workoutDate !== "mm/dd/yyyy") {
        if (this.props.editableWorkout) {
          this.updateWorkout();
        } else {
          this.addWorkout();
        }
      } else {
        immediateToast("warning", {
          message: Date_Error,
        });
      }
    };

    createDescription = () => {
      let description = "";
      let i = 0;
      let percentage;
      for (i = 0; i < this.state.descriptionArray.length; i++) {
        percentage = this.state.descriptionArray[i].percentage;
        if (!percentage) {
          percentage = 100;
        }
        description += `#${i + 1}: ${
          this.state.descriptionArray[i].reps
        }Reps ${percentage}% \n`;
      }

      return description;
    };

    updateWorkout = async () => {
      let url = this.props.isDupilicate
        ? `${projectSettings.baseUrl}/workouts/create`
        : `${projectSettings.baseUrl}/workouts/update/${this.props.trackWorkoutId}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data;

      let newFromDate = new Date(this.props.workoutDate);
      newFromDate = new Date(
        newFromDate.getTime() - newFromDate.getTimezoneOffset() * 60000
      );

      if (this.state.duplicateTrackId) {
        const scoreTypeNumber = 5; // by default it is dead lift
        const sets = parseInt(this.state.descriptionArray.length);
        const description = this.createDescription();

        data = {
          Name: this.state.name,
          Description: description,
          Notes: this.state.notes,
          Sets: sets,
          ScoreType: scoreTypeNumber,
          videoUrl: this.state.link,
          Schedule: newFromDate,
          WorkoutType: "Deadlift",
          BenchmarkValues: this.state.percentage,
        };

        if (this.props.isDupilicate) {
          data.TrackId = this.state.duplicateTrackId;
        }
        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          this.props.isDupilicate
            ? apiResponseToast(
                response.status,
                "duplicateWorkout",
                response.data.message
              )
            : apiResponseToast(
                response.status,
                "editWorkout",
                response.data.message
              );

          this.setState({ isLoading: false });
          if (response.type === "error") {
            this.props.shouldDuplicate();
          } else if (response.type === "success") {
            this.props &&
              this.props.resetOnCloseModal &&
              this.props.resetOnCloseModal();

            closeModel(this.props.modalId);

            this.props.workoutApiCalled();
            this.props.shouldDuplicate();

            response = "";
          }
        }
      } else {
        this.liftToast();
      }
    };

    addWorkout = async () => {
      let url = `${projectSettings.baseUrl}/workouts/create`;
      let header = true;
      let data = null;
      let type = "POST";
      let token = getPlainToken();

      let trackInfo = this.props ? this.props.trackInfo : null;

      let newFromDate = new Date(this.props.workoutDate);
      newFromDate = new Date(
        newFromDate.getTime() - newFromDate.getTimezoneOffset() * 60000
      );

      if (trackInfo.Id) {
        const scoreTypeNumber = 5; // by default it is dead lift
        const sets = parseInt(this.state.descriptionArray.length);
        const description = this.createDescription();

        data = {
          Name: this.state.name,
          Description: description,
          Notes: this.state.notes,
          Sets: sets,
          ScoreType: scoreTypeNumber,
          VideoUrl: this.state.link,
          Schedule: newFromDate,
          WorkoutType: "Deadlift",
          TrackId: trackInfo.Id,
          benchmarkValues: this.state.descriptionArray.map((currVal, index) => {
            let percentage = currVal.percentage;
            if (!percentage) {
              percentage = 100;
            }
            return percentage;
          }),

          MovementsIds: [this.state.selectedLiftOption.value],
        };

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          apiResponseToast(
            response.status,
            "addWorkout",
            response.data.message
          );

          this.setState({ isLoading: false });
          if (response.type === "error") {
          } else if (response.type === "success") {
            this.props.workoutApiCalled();

            this.resetState();
            this.props &&
              this.props.resetOnCloseModal &&
              this.props.resetOnCloseModal();

            !this.props.closeModal && closeModel(this.props.modalId);
            response = "";
          }
        }
      } else {
        this.setState({ showError: true });
      }
    };

    formatPercentage = () => {
      let i = 0;
      let tempArray = this.state.percentage;

      for (i = 0; i < this.state.percentage.length; i++) {
        if (!this.state.percentage[i]) {
          tempArray[i] = 100;
        }
      }

      this.setState({ percentage: tempArray });
    };

    selectSets = (selectedOption) => {
      var sets = selectedOption.value;
      this.setState({
        selectedSetOption: { label: parseInt(sets), value: parseInt(sets) },
      });

      var repsPercentage = {
        percentage: "",
        reps: "",
      };
      var newArr = this.state.descriptionArray;
      if (this.state.descriptionArray.length < sets) {
        for (let i = this.state.descriptionArray.length; i < sets; i++) {
          newArr.push(repsPercentage);
        }
        this.setState({
          descriptionArray: newArr,
        });
      } else if (this.state.descriptionArray.length > sets) {
        for (
          let i = this.state.descriptionArray.length - 1;
          i > sets - 1;
          i--
        ) {
          newArr.pop();
        }
        this.setState({
          descriptionArray: newArr,
        });
      }
    };

    selectLift = (selectedOption) => {
      this.setState({
        selectedLiftOption: selectedOption,
      });
    };

    changeReps = (index, value) => {
      let tempArray1 = this.state.descriptionArray;
      let i;
      let limit = this.state.descriptionArray.length;
      let initValue = parseInt(value);

      for (i = 0; i < limit; i++) {
        if (i === index) {
          if (initValue) {
            tempArray1[i] = {
              reps: initValue,
              percentage: tempArray1[i].percentage,
            };
          } else {
            tempArray1[i] = {
              reps: "",
              percentage: tempArray1[i].percentage,
            };
          }
        }
      }

      this.setState({ descriptionArray: tempArray1 });
    };

    changePercentage = (index, value) => {
      let tempArray2 = this.state.descriptionArray;
      let i;
      let limit = this.state.descriptionArray.length;
      let initValue = parseInt(value);

      for (i = 0; i < limit; i++) {
        if (i === index) {
          if (value) {
            tempArray2[i] = { reps: tempArray2[i].reps, percentage: initValue };
          } else {
            tempArray2[i] = { reps: tempArray2[i].reps, percentage: "" };
          }
        }
      }

      this.setState({ descriptionArray: tempArray2 });
    };

    resetState = () => {
      this.nameRef.current.value = null;
      this.linkRef.current.value = null;
      this.notesRef.current.value = null;

      this.props.closeModal && this.props.closeModal();

      this.setState({
        id:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Id
            : null,
        totalSets: 10,
        selectedSets: 0,
        isLoading: false,
        date:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Schedule
            : this.props.workoutDate
            ? this.props.workoutDate
            : "mm/dd/yyyy",
        name:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Name
            : "",
        link:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.videoUrl
            : "",
        notes:
          this.props && this.props.editableWorkout
            ? this.props.editableWorkout.Notes
            : "",
        descriptionArray: [{ reps: "", percentage: "" }],
        selectedSetOption: { label: 1, value: 1 },
      });
    };

    render() {
      return (
        <div>
          <form onSubmit={this.submitHandler}>
            <div className="container mx-auto row p-0">
              <div className="col-lg-6 col-md-6 col-sm-12 p-0 pr-2">
                <Select
                  className={`react-select`}
                  placeholder="Lift Types"
                  value={this.state.selectedLiftOption}
                  options={this.state.liftOptions}
                  onChange={this.selectLift}
                  styles={customStyles}
                />
                <input
                  url="text"
                  className="form-control form-control-sm pl-2 mt-2 inputFieldStyle"
                  placeholder="Workout Name"
                  id="name"
                  maxLength="100"
                  ref={this.nameRef}
                  defaultValue={
                    this.props && this.props.editableWorkout
                      ? this.state.name
                      : ""
                  }
                  required
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
                <input
                  url="url"
                  className="form-control form-control-sm pl-2 mt-2 quinaryColor mb-2 inputFieldStyle"
                  placeholder="Enter Youtube Link"
                  id="link"
                  ref={this.linkRef}
                  defaultValue={
                    this.props && this.props.editableWorkout
                      ? this.state.link
                      : ""
                  }
                  onChange={(e) => this.setState({ link: e.target.value })}
                />
                <Select
                  className={`react-select`}
                  placeholder="Sets"
                  value={this.state.selectedSetOption}
                  options={setsOption}
                  onChange={this.selectSets}
                  styles={customStyles}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 p-0">
                <textarea
                  className="form-control rounded quinaryColor inputFieldStyle"
                  id="notes"
                  rows="10"
                  placeholder="Notes"
                  ref={this.notesRef}
                  defaultValue={
                    this.props && this.state.notes ? this.state.notes : ""
                  }
                  onChange={(e) => this.setState({ notes: e.target.value })}
                ></textarea>
              </div>
              <div className="table-responsive mt-2 workOutTable ml-2 mt-3 mr-2 primaryScrollBar inputFieldStyle">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th class="colPadding">Sets #</th>
                      <th class="colPadding">Reps</th>
                      <th class="colPadding">Percentage %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.descriptionArray.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td class="colPadding"> {index + 1}</td>
                          <td class="colPadding">
                            <input
                              className="border-0"
                              type="number"
                              min="0"
                              max="100"
                              value={item.reps}
                              required
                              onChange={(e) =>
                                this.changeReps(index, e.target.value)
                              }
                            />
                          </td>
                          <td class="colPadding">
                            <input
                              className="border-0"
                              type="number"
                              min="0"
                              max="100"
                              value={item.percentage}
                              onChange={(e) =>
                                this.changePercentage(index, e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center w-100 mt-3 mb-2">
              <button
                className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
                data-dismiss="modal"
                onClick={() => {
                  typeof this?.props?.closeModal === "function" &&
                    this?.props?.closeModal();
                }}
              >
                Cancel
              </button>

              <button
                className="basicFatBtnStyle primaryBtn colorWhite"
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <div>
                    <Spinner />
                  </div>
                ) : this.props.isDupilicate ? (
                  <span>Duplicate</span>
                ) : this.props.editableWorkout ? (
                  <span>Update</span>
                ) : (
                  <span>Save</span>
                )}
              </button>
            </div>
          </form>
        </div>
      );
    }
  }
);

const customStyles = {
  menuList: () => ({
    maxHeight: 200,
    overflow: "auto",
  }),
};
